document.addEventListener("DOMContentLoaded", function () {
  //   write your code here

  // yg-grid-swiper
  class YGGridSwiper extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      this.swiperStyle();
    }

    swiperStyle() {
      let swiper = this;
      let $count = swiper.getAttribute('data-item-count') ? swiper.getAttribute('data-item-count') : 4;
      let $Gap = swiper.getAttribute('data-item-gap') ? swiper.getAttribute('data-item-gap') : 24;
      let $BlockSize = swiper.getAttribute('data-blocks-size');
      let $btn = swiper.querySelector('.swiper-btn');
      if (Number($BlockSize) <= 4) {
        new Swiper(swiper, {
          slidesPerView: $BlockSize,
          spaceBetween: 15,
          breakpoints: {
            //当宽度大于等于768
            300: {
              slidesPerView: 1.2,
              spaceBetween: 15,
            },
            768: {
              slidesPerView: $BlockSize,
              spaceBetween: $Gap,
            },
          },
        });
        $btn.style.display = "none";
      } else {
        new Swiper(swiper, {
          slidesPerView: 1.2,
          spaceBetween: 15,
          breakpoints: {
            //当宽度大于等于768
            300: {
              slidesPerView: 1.2,
              spaceBetween: 15,
            },
            768: {
              slidesPerView: 1.5,
              spaceBetween: $Gap * 0.4,
            },
            //当宽度大于等于900
            900: {
              slidesPerView: $count,
              spaceBetween: $Gap,
            },
          },
          scrollbar: {
            el: ".swiper-scrollbar",
            clickable: true,
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        });
        $btn.style.display = "flex";
      }
    }
  }

  if (!window.customElements.get("yg-grid-swiper")) {
    window.customElements.define("yg-grid-swiper", YGGridSwiper);
  }

  function formatMoney(cents, format = "") {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
      formatString = format || window.themeVariables.settings.moneyFormat;

    function defaultTo(value2, defaultValue) {
      return value2 == null || value2 !== value2 ? defaultValue : value2;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ",");
      decimal = defaultTo(decimal, ".");
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100).toFixed(precision);
      let parts = number.split("."),
        dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + thousands,
        ),
        centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount;
    }

    let value = "";
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ".");
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_no_decimals_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 0, "'");
        break;
    }
    if (formatString.indexOf("with_comma_separator") !== -1) {
      return formatString.replace(placeholderRegex, value);
    } else {
      return formatString.replace(placeholderRegex, value);
    }
  }

  class YGBundle extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      this.$headers = this.querySelectorAll(".yg-bundle-header-tab");
      this.$blocks = this.querySelectorAll(".yg-bundle-product-list");

      this.$headers.forEach((header, index) => {
        header.addEventListener("click", () => this.switchTab(index));
      });

      this.toggleDropdown();
      this.showMore();
      this.checkboxBinder();
      this.variantPicker();
    }

    switchTab(index) {
      this.$headers.forEach((header) => header.classList.remove("active"));
      this.$blocks.forEach((panel) => panel.classList.remove("active"));

      this.$headers[index].classList.add("active");
      this.$blocks[index].classList.add("active");
    }

    toggleDropdown() {
      this.$btns = this.querySelectorAll(".yg-bundle-variant-picker");
      this.$btns.forEach((btn, index) => {
        btn.addEventListener("click", (event) => {
          event.stopPropagation();
          const $fieldset = btn.closest(".yg-bundle-variant-fieldset");
          const $dropdown = $fieldset.querySelector(".yg-bundle-variant-list");
          const isActive = btn.classList.contains("active");
          this.closeAllDropdowns();
          // btn.classList.toggle('active');
          // $dropdown.classList.toggle('active');
          if (!isActive) {
            btn.classList.add("active");
            $dropdown.classList.add("active");
          }
        });
      });

      document.addEventListener("click", (event) => {
        if (!event.target.closest(".yg-bundle-variant-picker")) {
          this.closeAllDropdowns();
        }
      });
    }

    closeAllDropdowns() {
      this.$btns.forEach((btn) => btn.classList.remove("active"));
      this.querySelectorAll(".yg-bundle-variant-list").forEach(($dropdown) => {
        $dropdown.classList.remove("active");
      });
    }

    showMore() {
      this.$buttons = this.querySelectorAll(".yg-bundle-more-button");
      this.$buttons.forEach((btn) => {
        btn.addEventListener("click", () => {
          const $list = btn.closest(".yg-bundle-product-list");
          const $items = $list.querySelectorAll(".yg-bundle-item");
          const $hiddenItems = $list.querySelectorAll(".yg-bundle-item.hidden");
          const isShowingMore =
            btn.textContent.trim() === window.expand_btn.more_btn;

          if (isShowingMore) {
            $hiddenItems.forEach((item) => {
              item.classList.remove("hidden");
            });
            btn.textContent = window.expand_btn.less_btn;
          } else {
            $items.forEach((item, index) => {
              if (index >= 3) {
                item.classList.add("hidden");
              }
            });
            btn.textContent = window.expand_btn.more_btn;
          }
        });
      });
    }

    checkboxBinder() {
      const $checkboxes = this.querySelectorAll(
        '.yg-bundle-item input[type="checkbox"]',
      );
      $checkboxes.forEach((checkbox) => {
        checkbox.addEventListener("change", () => {
          const bundleItem = checkbox.closest(".yg-bundle-item");
          bundleItem.classList.toggle("active", this.checked);

          this.applyPromotion();
        });
      });
    }

    applyPromotion() {
      const $allPromoItems = this.querySelectorAll(
        ".yg-bundle-product-list.is-promotion .yg-bundle-item",
      );
      const $promoItems = this.querySelectorAll(
        ".yg-bundle-product-list.is-promotion .yg-bundle-item.active",
      );
      if (!$allPromoItems.length) {
        return;
      }
      const selectedPromoCount = $promoItems.length;

      const $promoHeader = this.querySelector(
        ".yg-bundle-header-tab.is-promotion",
      );
      const $limit =
        parseInt($promoHeader?.getAttribute("data-discount-limit")) || 0;
      const discountRate =
        parseFloat($promoHeader?.getAttribute("data-discount-rate")) || 0;

      let totalOriginalPrice = 0;
      let totalDiscountedPrice = 0;
      const remaining = $limit - selectedPromoCount;
      $allPromoItems.forEach((item) => {
        const priceContainer = item.querySelector(".yg-bundle-item-price");
        const salePriceDiv = priceContainer.querySelector(".price-sale");
        const regularPriceDiv = priceContainer.querySelector(".price-regular");
        const salePriceSpan = salePriceDiv.querySelector(".price-money");
        if (selectedPromoCount >= $limit && $limit > 0) {
          const originalSalePrice = parseFloat(item.dataset.salePrice);
          const originalRegularPrice = originalSalePrice;

          salePriceSpan.innerHTML = formatMoney(
            originalSalePrice * (1 - discountRate / 100),
          );

          let regularPriceSpan = regularPriceDiv.querySelector(".price-money");
          if (!regularPriceSpan) {
            regularPriceSpan = document.createElement("span");
            regularPriceSpan.className = "price-money";
            const hiddenSpan =
              regularPriceDiv.querySelector(".visually-hidden");
            if (hiddenSpan) {
              hiddenSpan.insertAdjacentElement("afterend", regularPriceSpan);
            } else {
              regularPriceDiv.appendChild(regularPriceSpan);
            }
          }
          regularPriceSpan.innerHTML = formatMoney(originalRegularPrice);
          regularPriceDiv.classList.remove("hidden");
        } else if (selectedPromoCount < $limit) {
          const originalSalePrice = formatMoney(
            parseFloat(item.dataset.salePrice),
          );
          const originalRegularPrice = parseFloat(item.dataset.regularPrice);

          salePriceSpan.innerHTML = originalSalePrice;

          const regularPriceSpan =
            regularPriceDiv.querySelector(".price-money");
          if (regularPriceSpan) {
            if (originalRegularPrice) {
              regularPriceSpan.innerHTML = formatMoney(originalRegularPrice);
            } else {
              regularPriceSpan.innerHTML = "";
              regularPriceDiv.classList.add("hidden");
            }
          }
        }
      });

      if (remaining > 0) {
        $promoHeader.textContent = `Add ${remaining}, save ${discountRate}%`;
      } else {
        $promoItems.forEach((item) => {
          const originalPriceElement =
            item.querySelector(".price.price-regular .price-money") ||
            item.querySelector(".price.price-sale .price-money");

          console.log("originalPriceElement: ", originalPriceElement);
          const salePriceElement = item.querySelector(
            ".price.price-sale .price-money",
          );

          let originalPrice =
            parseFloat(
              originalPriceElement.textContent.replace(/[^0-9.]/g, ""),
            ) * 100;

          let salePrice =
            parseFloat(salePriceElement.textContent.replace(/[^0-9.]/g, "")) *
            100;

          totalOriginalPrice += originalPrice;
          totalDiscountedPrice += salePrice;
        });

        const totalSavings = formatMoney(
          totalOriginalPrice - totalDiscountedPrice,
        );

        const totalHtml = document.createElement("div");
        totalHtml.innerHTML = totalSavings;
        const savingsText = totalHtml.textContent || totalHtml.innerText;
        $promoHeader.textContent = `Order Now & Save ${savingsText}`;
      }
    }

    variantPicker() {
      const $variants = this.querySelectorAll(".yg-bundle-variant-list li");
      Array.from($variants).forEach((variantInput) => {
        variantInput.addEventListener("click", () => {
          const $fieldset = variantInput.closest(".yg-bundle-variant-fieldset");
          const variantPicker = $fieldset.querySelector(
            ".yg-bundle-variant-picker",
          );
          const $list = variantInput.closest(".yg-bundle-variant-list");
          variantPicker.classList.remove("active");
          $fieldset.classList.remove("active");
          $list.classList.remove("active");
          variantPicker.querySelector("span").innerHTML =
            variantInput.innerHTML;
          const variantId = variantInput.getAttribute("data-variant-id");
          let productItem = variantPicker.closest(".yg-bundle-item");
          productItem.setAttribute("data-product-id", variantId);

          this.updateProduct(variantInput, productItem);
        });
      });
    }

    updateProduct(variantInput, productItem) {
      if (productItem) {
        const productHandle = productItem.getAttribute("data-product-handle");
        const variantId = variantInput.getAttribute("data-variant-id");

        const salePrice = productItem.querySelector(".price.price-sale");
        const regularPrice = productItem.querySelector(".price.price-regular");

        const clearOldPrice = (priceContainer) => {
          priceContainer
            .querySelectorAll(".price-money")
            .forEach((el) => el.remove());
        };

        if (productHandle && variantId) {
          fetch(window.Shopify.routes.root + `products/${productHandle}.js`)
            .then((response) => {
              if (!response.ok) {
                throw new Error(
                  `Failed to fetch product: ${response.statusText}`,
                );
              }
              return response.json();
            })
            .then((product) => {
              const matchingVariant = product.variants.find(
                (variant) => variant.id.toString() === variantId,
              );
              // console.log("matchingVariant: ", JSON.stringify(matchingVariant, null, 2));

              if (matchingVariant.price) {
                clearOldPrice(salePrice);

                const salePriceHtml = formatMoney(matchingVariant.price);
                let salePriceSpan = salePrice.querySelector(".price-money");
                if (!salePriceSpan) {
                  salePriceSpan = document.createElement("span");
                  salePriceSpan.className = "price-money";
                  salePriceSpan.innerHTML = salePriceHtml;
                } else {
                  salePriceSpan.innerHTML = salePriceHtml;
                }

                salePrice.appendChild(salePriceSpan);
                productItem.setAttribute(
                  "data-sale-price",
                  matchingVariant.price,
                );
              }

              if (matchingVariant.compare_at_price) {
                clearOldPrice(regularPrice);

                const regularPriceHtml = formatMoney(
                  matchingVariant.compare_at_price,
                );
                let regularPriceSpan =
                  regularPrice.querySelector(".price-money");
                if (!regularPriceSpan) {
                  regularPriceSpan = document.createElement("span");
                  regularPriceSpan.className = "price-money";
                  regularPriceSpan.innerHTML = regularPriceHtml;
                } else {
                  regularPriceSpan.innerHTML = regularPriceHtml;
                }
                regularPrice.appendChild(regularPriceSpan);
                productItem.setAttribute(
                  "data-regular-price",
                  matchingVariant.compare_at_price,
                );
              }

              this.applyPromotion();

              const productAvailable = matchingVariant.available;
              if (productAvailable === true) {
                variantInput.classList.remove("disabled");
              } else {
                variantInput.classList.add("disabled");
              }
            })
            .catch((error) => {
              console.error("Error fetching product:", error);
            });
        }
      }
    }
  }

  if (!window.customElements.get("yg-bundle")) {
    customElements.define("yg-bundle", YGBundle);
  }
  class YGHeader extends HTMLElement {
    constructor() {
      super()
      this.init();
    }
    init() {
      this.ygtitlehover()
    }
    ygtitlehover() {
      const $cols = this.querySelectorAll(".yg-collection")
      const $prolist = this.querySelectorAll(".yg-collection-menu")
      $cols.forEach((item,index)=>{
        item.addEventListener("click",function(){
          $cols.forEach((el)=>{
            el.classList.remove("active")
          })
          $prolist.forEach((el)=>{
            el.classList.remove("active")
          })
          $prolist[index].classList.add("active")
          item.classList.add("active")
        })
      })
    }
  }
  if (!window.customElements.get("yg-header")) {
    customElements.define("yg-header", YGHeader);
  }
});

